<template>
    <b-modal id="dpad1Modal" 
        static
        size="huge"
        :title="$t('dpad.addDpad1')" 
        hide-footer 
        @hidden="clearForm();">
        <b-overlay :show="showOverlay" rounded="sm">
            <b-form v-on:submit.prevent="createDpad1">
                <b-form-row class="mb-3">
                    <b-col sm="auto" lg="4">
                        <label for="contractNumber">{{ $t('dpad.dForm.contractNumber') }}</label>
                        <input  id="contractNumber" 
                            class="form-control" 
                            required
                            v-model="dForm.contractNumber">
                    </b-col>
                    <b-col sm="auto" lg="4">
                        <label for="dName">{{ $t('dpad.dForm.dName') }}</label>
                        <input  id="dName" 
                            required
                            class="form-control" 
                            v-model="dForm.dName">
                    </b-col>
                    <b-col sm="auto" lg="4">
                        <label for="beginDate">{{ $t('dpad.dForm.beginDate') }}</label>
                        <input  id="beginDate" 
                            required
                            type="date"
                            class="form-control" 
                            v-model="dForm.beginDate">
                    </b-col>
                </b-form-row>
                
                <b-form-row class="mb-3">
                    <b-col sm="auto" lg="4">
                        <label for="tenderPrice">{{ $t('dpad.dForm.tenderPrice') }}</label>
                        <input  id="tenderPrice" 
                            class="form-control" 
                            v-model.number="dForm.tenderPrice">
                    </b-col>
                    <b-col sm="auto" lg="4">
                        <label for="departments">{{ $t('dpad.dForm.departments') }}</label>
                        <multiselect 
                            v-model="dForm.departments" 
                            :options="departments"
                            :multiple="true"
                            track-by="depNameRu"
                            :custom-label="customLabel"
                            >
                        </multiselect>
                    </b-col>

                    <b-col sm="auto" lg="4">
                        <label for="organizations">{{ $t('pForm.organizations') }}</label>
                        <multiselect 
                            v-model="dForm.organizations" 
                            :options="organizations"
                            :multiple="true"
                            track-by="orgName"
                            :custom-label="customLabelForOrg"
                        >
                        </multiselect>
                    </b-col>
                </b-form-row>
                <b-form-row class="mb-3">
                    <b-col sm="auto" lg="4">
                        <label for="typeId">{{ $t('dpad.dForm.fType') }}</label>
                        <select required id="typeId" 
                            class="form-control" 
                            v-model.number="dForm.typeId">
                            <option value=0>
                                {{ $i18n.locale()=='kz' ? 'Таңдаңыз...' : 'Выберите...' }}
                            </option>
                            <option v-for="t in types" :value=t.typeId>
                                {{ $i18n.locale()=='kz' ? t.typeName :t.typeNameRu}} 
                            </option>
                        </select>
                    </b-col>
                    <b-col sm="auto" lg="4">
                        <label for="tenderType">{{ $t('dpad.dForm.tenderType') }}</label>
                        <select required id="tenderType" 
                            class="form-control" 
                            v-model.number="dForm.tenderType">
                            <option value=0>
                                {{ $i18n.locale()=='kz' ? 'Таңдаңыз...' : 'Выберите...' }}
                            </option>
                            <option value=1>
                                Открытый тендер/аукцион tender
                            </option>
                            <option value=2>
                                Запрос ценовых предложений
                            </option>
                        </select>
                    </b-col>
                    <b-col sm="auto" lg="4">
                        <label for="bankPrice">{{ $t('dpad.dForm.bankPrice') }}</label>
                        <input  id="bankPrice" 
                            class="form-control" 
                            v-model.number="dForm.bankPrice">
                    </b-col>
                </b-form-row>
                <b-form-row class="mb-3">
                    <b-col cols="12">
                        <label for="year" >{{ $t('dpad.dForm.year') }}</label>
                        <input type="number" id="year" class="form-control w-50 mb-2" placeholder="year" v-model.number="dForm.date.year">
                    </b-col>
                    <b-col cols="3"  v-for="(i,ii) in 12" class="mb-1" :key="ii">
                        <label  :for="'month'+i">{{ $t('dpad.dForm.month'+i) }}</label>
                        <input :placeholder="'month-'+i" 
                        :id="'month'+i"
                        class="form-control" type="number" v-model.number="dForm.date.months[i-1].mv">
                    </b-col>
                </b-form-row>
                <b-form-row>
                    <b-col lg="12">
                        <b-row class="pt-2">
                            <b-col lg="6">
                                <b-button size="sm" block variant="primary" @click="closeModal()" class="mr-2" >{{$t("hForm.back")}}</b-button>
                            </b-col>
                            <b-col lg="6">
                                <b-button size="sm" block variant="success" type="submit" >{{$t("dpad.dForm.addDpad1")}}</b-button>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-form-row>
            </b-form>
        </b-overlay>
       
    </b-modal>
</template>
<script>
    import axios from 'axios';
    import {apiDomain,getHeader,getMultipartHeader} from "@/config/config";
    import Multiselect from 'vue-multiselect'
    import  'vue-multiselect/dist/vue-multiselect.min.css';
    export default {
        name:"DpadForm1",
        props:["types","departments","sysChange"],
        components:{
            Multiselect,
           
        },
        data(){
            return {
                dForm:{
                    dId:0,
                    contractNumber:"",
                    dpadType:1,
                    departments:"",
                    dName:"",
                    tenderPrice:0,
                    beginDate:"",
                    organizations:[],
                    tenderType:0,
                    typeId:0,
                    date:{
                        year:0,
                        months: Array.from({ length: 12 }, (_, index) => ({ "month":index+1, 'mv': 0 }))
                    },
                    bankPrice:0

                },
                organizations:[],
                showOverlay:false,
            }
        },
        methods:{
            customLabelForOrg (option) {
                return `${option.orgName} - ${option.bin}`
            },
            customLabel (option) {
                return `${option.depName} - ${option.depNameRu}`
            },
            createDpad1(){
                console.info("dForm > ",this.dForm);   
                this.showOverlay=true;
                if (this.dForm.departments.length==0){
                    alert("Выберите отделы");
                    this.showOverlay=false;
                    return;
                }
                if (this.dForm.organizations.length==0){
                    alert("Выберите организации");
                    this.showOverlay=false;
                    return;
                }
                if (this.dForm.typeId==0){
                    alert("Выберите тип");
                    this.showOverlay=false;
                    return;
                }
                if (this.dForm.tenderType==0){
                    alert("Выберите тип тендера");
                    this.showOverlay=false;
                    return;
                }
                axios.post(apiDomain+"/dpad1/create",this.dForm,{headers:getHeader()})
                .then(res=>{
                    console.info("res > ",res);
                    this.showOverlay=false;
                    this.clearForm();
                    this.sysChange();
                    this.$bvModal.hide("dpad1Modal");
                    
                }).catch(err=>{
                    console.error("err > ",err);
                    this.showOverlay=false;
                });
            },
            closeModal(){
                this.clearForm();
                this.$bvModal.hide("dpad1Modal");
            },
           
            
            clearForm(){
                this.dForm={
                    dId:0,
                    contractNumber:"",
                    dpadType:1,
                    departments:"",
                    dName:"",
                    tenderPrice:0,
                    beginDate:"",
                    organizations:[],
                    tenderType:0,
                    typeId:0,
                    date:{
                        year:0,
                        months: Array.from({ length: 12 }, (_, index) => ({ "month":index+1, 'mv': 0 }))
                    },
                    bankPrice:0

                }
                
            },
            listOrganization(){
            
                axios.post(apiDomain+'/p/listorganization',{},{headers:getHeader()})
                .then(response=>{
                    this.organizations=response.data;
                    //alert(JSON.stringify(this.organizations));
                })
                .catch(error => {
                    alert(error.message);
                })
            }
            
        },
        created(){
            this.listOrganization();
        }
    }
</script>
<style >
  .modal .modal-huge {
    max-width: 80%;
  }
</style>